export default "__VITE_ASSET__cf6be231__"